import React, { FC } from 'react';
import DesktopFreeItemsModal from '../../../../modals/free-items/FreeItemsModal';
import { IModal } from '../../router/ModalRouter';
import { FreeItemsModalProps } from '../../../../services/exports/Interfaces';
import useModalRouter from '../../common/hooks/useModalRouter';

const FreeItemsModal: FC<Partial<IModal> & FreeItemsModalProps> = ({ offer }) => {
  const { closeModal } = useModalRouter();

  return <DesktopFreeItemsModal openModal={true} offer={offer} onClose={closeModal} />;
};

export default FreeItemsModal;
